module.exports = __webpack_public_path__ + "img/phuket-beer-phuket.0ba66577.png";